'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global initialize*/

(function ($) {
  var methods = {
    init: function (options) {

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('filter-load-summary-init')) {
          return;
        }

        $this.addClass('filter-load-summary-init');

        _this.options = $.extend({}, $.fn.k2_filterLoadSummary.defaults, options);
        _this.timeout = null;
        _this.isLoading = false;
        _this.hasLoadingRequest = false;
        $this.on('submit', function () {
          clearTimeout(_this.timeout);
          methods.submit.apply(_this, arguments);

          return false;
        });

        $this.on('change keyup', 'input, select, textarea', function () {
          clearTimeout(_this.timeout);

          _this.timeout = setTimeout(function () {
            methods.submit.apply(_this, arguments);
          }, _this.options.loadDelay);

          return false;
        });
      });
    },

    submit: function () {
      var _this = this;
      var $this = $(this);

      var $container = $($this.data('container'));
      var data = $this.serialize();

      //zabranime vicenasobnemu odeslani, tak aby se dotazy neprekryvaly
      if (!_this.isLoading) {
        _this.hasLoadingRequest = false;
        _this.isLoading = true;
        blockElement($container);

        $.get($this.attr('href'), data + '&ajax=1', function (res) {
          _this.isLoading = false;
          unBlockElement($container);

          $container.html(res);
          if ('initialize' in window) {
            initialize($container);
          }

          if ($.isFunction(_this.options.onLoadCallback)) {
            _this.options.onLoadCallback({ container: $container });
          }

          //pokud behem nacitani prisel dalsi pozadavek, tak jej o chvilce take posleme
          if (_this.hasLoadingRequest) {
            _this.timeout = setTimeout(function () {
              methods.submit.apply(_this, arguments);
            }, _this.options.loadDelay);
          }
        });
      } else {
        //pokud je ale dalsi dotaz, tak jej posleme po nacteni predchoziho
        _this.hasLoadingRequest = true;
      }
    }
  };

  $.fn.k2_filterLoadSummary = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_filterLoadSummary');
    }
  };

  $.fn.k2_filterLoadSummary.defaults = {
    onLoadCallback: null,
    loadDelay: 300 //v ms - zpozdeni mezi stiskem klavesy a nacitani
  };

})(jQuery);
